<account-back [title]="'Payment methods' | translate"
class="m-b-9 m-b-7-s m-b-7-m m-t--1 block p-l-2"></account-back>

@if (!cards?.length) {
  <p class="s1"
    cy-savedCardBookEmpty>
    {{ 'You don\'t have any saved cards.' | translate }}
  </p>
}

@if (cards?.length) {
  <div [grid]="client.sizeId > 1 ? 2 : 1"
    [gridColumnGap]="'20px'"
    [gridRowGap]="'20px' "
    >
    @for (card of cards; track card) {
      <account-saved-card-item [gridColumn]="1"
      [card]="card"></account-saved-card-item>
    }
  </div>
}

<p class="col-12"
  [sizeClass]="'SM:c1 center m-t-15, XL:p1 m-t-9'">{{'You will be able to add a new payment method at your next
purchase.' |translate }}</p>
